<template>
  <div class="assignation">
    <div class="assignation-title">
      <h3>{{ $t("INSPECTIONS.ASSIGN_INSPECTION") }}</h3>
    </div>
    <div class="assignation-inspectors">
      <h3>{{ $t("INSPECTIONS.INSPECTORS") }}</h3>
      <p>{{ $t("INSPECTIONS.ASSIGNE_TO_INSPECTORS") }}</p>
      <div class="radio-selection">
        <el-radio v-model="roleSelector" label="-1" :disabled="disabled">
          {{ $t("INSPECTIONS.CHOOSE_INSPECTOR") }}
        </el-radio>
      </div>
      <Button
        v-if="!isRoleAssignment && !disabled"
        class="add-inspector"
        @click="showMechanicSelectionModal = true"
      >
        <i class="fal fa-plus"></i>
        <span>{{ $t("INSPECTIONS.ADD_INSPECTOR") }}</span>
      </Button>
      <div v-if="!isRoleAssignment && usersModel != []" class="mechanic-list">
        <el-tag
          :key="tag"
          v-for="tag in usersModel"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)"
        >
          {{ $objectDenomination(getUser(tag)) }}
        </el-tag>
      </div>
      <div class="radio-selection">
        <el-radio
          v-for="role in rolesList"
          v-model="roleSelector"
          :label="role.id"
          :key="role.id"
          :disabled="disabled"
        >
          <span
            v-html="`${$t('COMMON.ALL_USERS_WITH_ROLE', { name: role.name })}`"
          ></span>
        </el-radio>
      </div>
    </div>

    <modal
      :show.sync="showMechanicSelectionModal"
      modal-classes="modal-secondary mechanic-list"
      v-if="!disabled"
    >
      <template slot="header">
        <h3>{{ $t("INSPECTIONS.ADD_INSPECTOR") }}</h3>
      </template>

      <p>{{ $t("INSPECTIONS.ADD_INSPECTOR") }}</p>
      <div class="search-form">
        <el-input
          :placeholder="$t('INSPECTIONS.ADD_INSPECTOR')"
          v-model="userSearch"
        >
          <i slot="prefix" class="fal fa-search"></i>
        </el-input>
      </div>
      <div class="others">
        <!-- <p>Autres</p> -->
        <div class="mechanic-checkbox">
          <el-checkbox-group v-model="usersModel">
            <el-checkbox
              v-for="user in userFiltered"
              :key="user.id"
              :label="user.id"
            >
              {{ $objectDenomination(user) }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <template slot="footer">
        <Button class="yes" @click="submit">
          {{ $t("COMMON.END") }}
        </Button>
      </template>
    </modal>
  </div>
</template>

<script>
import { Checkbox, CheckboxGroup, Radio, Tag } from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import _ from "lodash";
import locationMixin from "@/mixins/location-mixin";

export default {
  name: "inspection-form-assignation-step",

  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [Tag.name]: Tag,
  },

  props: {
    inspectionData: {
      type: Object,
      required: true,
    },
    role: {
      type: [String, Number],
      default: -1,
    },
    users: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [requestErrorMixin, locationMixin],

  data() {
    const inspection = { ...this.inspectionData };
    const usersModel = this.users ?? [];
    const roleSelector = this.role ?? -1;
    let showMechanicSelectionModal = false;

    if (roleSelector == -1 && !this.disabled) {
      showMechanicSelectionModal = true;
    }
    return {
      usersList: [],
      rolesList: [],
      inspection,
      usersModel,
      roleSelector,
      userSearch: "",
      showMechanicSelectionModal,
    };
  },

  computed: {
    userFiltered() {
      return this.userSearch
        ? this.usersList.filter((user) =>
            this.$objectDenomination(user)
              .toLowerCase()
              .includes(this.userSearch.toLowerCase())
          )
        : this.usersList;
    },
    isRoleAssignment() {
      return this.roleSelector != "-1";
    },
  },

  async created() {
    await this.getRoles();
    await this.getUsers();
  },

  methods: {
    async getRoles() {
      try {
        let params = {
          sort: "name",
          filter: {
            permission: this.$permissions.PERM_START_INSPECTIONS,
            organization: this.inspection.organization.id,
          },
          ignore_location_filter: true,
          // page: {
          //   number: 1,
          //   size: 10,
          // },
        };

        await this.$store.dispatch("roles/list", params);

        this.rolesList = await this.$store.getters["roles/list"];
        // this.rolesList = {};
        // rolesArr.forEach((role) => {
        //   this.rolesList[role.id] = role;
        // });
      } catch (error) {
        this.showRequestError(error, false);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    async getUsers() {
      try {
        let params = {
          filter: {
            permission: this.$permissions.PERM_START_INSPECTIONS,
            organization: this.inspection.organization.id,
          },
          with_doesnt_have: true,
          // page: {
          //   number: 1,
          //   size: 10,
          // },
        };

        if (this.userSearch?.length) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              search: this.userSearch,
            },
          };
        }

        const filterLocation = this.inspection?.allowedLocations[0]?.id ?? null;

        if (this.isRestrictToOneLocation) {
          params = { ...params, ignore_location_filter: true };
        }

        if (filterLocation) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              allowedLocations: filterLocation,
            },
          };
        }

        await this.$store.dispatch("users/list", params);

        this.usersList = await this.$store.getters["users/list"];
        // this.usersList = {};
        // usersArr.forEach((user) => {
        //   this.usersList[user.id] = user;
        // });
      } catch (error) {
        this.showRequestError(error, false);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    handleClose(tag) {
      if (this.disabled) return;

      this.usersModel.splice(this.usersModel.indexOf(tag), 1);
    },
    getUser(userId) {
      return this.usersList.find((user) => user.id == userId);
    },

    submit() {
      this.showMechanicSelectionModal = false;
      this.$emit("submitAssignation");
    },
  },

  watch: {
    roleSelector(value) {
      this.$emit("update:role", value);
    },
    usersModel() {
      this.$emit("update:users", this.usersModel);
    },
  },
};
</script>

<style lang="scss" scoped></style>
